import { Injectable } from '@angular/core';
import { Signal } from '@angular/core';
import { ZonaModel } from '../services/zones/models/zona.model';
import { ZonesRepository } from '../repositories/zones-repository';
import { DataProvider } from '../providers/data-provider';

@Injectable({
  providedIn: 'root'
})
export class ZonesManager {
  public zones: Signal<ZonaModel[]>;

  public constructor(
    private zonesRepository: ZonesRepository
  ) {
    const provider = new DataProvider<ZonaModel>(this.zonesRepository);
    this.zones = provider.data;
  }

  public refreshZones(): void {
    this.zonesRepository.fetch();
  }

  public addZone(zone: ZonaModel): void {
    this.zonesRepository.save(zone);
  }

  public updateZone(zone: ZonaModel): void {
    this.zonesRepository.update(zone);
  }

  public deleteZone(id: number): void {
    this.zonesRepository.delete(id);
  }
}
